import React from "react";
import { array, object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import CustomStoryCard3 from "../../../../molecules/CustomStoryCard3";

import "./organism1.m.css";

const Organism1 = ({ stories, publisherAttributes }) =>
  stories.length > 0 && (
    <div styleName="base">
      {stories.map(({ story }, index) => (
        <div styleName="story-card" key={index}>
          <CustomStoryCard3
            story={story}
            updatedFont={true}
            publisherLang={publisherAttributes.lang}
            src="big-fact-org1"
          />
        </div>
      ))}
    </div>
  );

Organism1.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(Organism1);
